export const config = {
  VUE_APP_KEYCLOAK_URL: process.env.VUE_APP_KEYCLOAK_URL,
  VUE_APP_FILES_LOCATION: process.env.VUE_APP_FILES_LOCATION,
  VUE_APP_API_LOCATION: process.env.VUE_APP_API_LOCATION,
  VUE_APP_MODE: process.env.VUE_APP_MODE,
  VUE_APP_UNLEASH_FE_API_TOKEN: process.env.VUE_APP_UNLEASH_FE_API_TOKEN,
  VUE_APP_STRIPE_PUBLIC_KEY: process.env.VUE_APP_STRIPE_PUBLIC_KEY,
  VUE_APP_GOOGLE_PUBLIC_KEY: process.env.VUE_APP_GOOGLE_PUBLIC_KEY
}

export const s3_base_url = "https://projectsimple.s3.us-west-2.amazonaws.com"

export const isStaging = (): boolean => config.VUE_APP_MODE === "staging"
export const isLocalHost = () => config.VUE_APP_MODE === "development"
export const isProduction = () => config.VUE_APP_MODE === "production"
export const DEFAULT_MAX_UPLOAD_SIZE_MB = 500
export const trainingYoutubeVideoId = (): string => "IG5IHjAKYu8"
export const tutorialHowUseUnprioritized = (): string => "IG5IHjAKYu8"
